import axios from "axios";
import { API_ENDPOINTS } from "./ApiEndPoints";

const baseUrl = API_ENDPOINTS.getBaseUrl();

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add Authorization header
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration or unauthorized access
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear(); // clear all data
      window.location.href = "/genapp/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
